/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendRolePresetDto } from '../../models/backend-role-preset-dto';

export interface AccessRolePresetRetrieve$Params {
  pid: number;
}

export function accessRolePresetRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: AccessRolePresetRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendRolePresetDto>> {
  const rb = new RequestBuilder(rootUrl, accessRolePresetRetrieve.PATH, 'get');
  if (params) {
    rb.path('pid', params.pid, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendRolePresetDto>;
    }),
  );
}

accessRolePresetRetrieve.PATH = '/api/access/role-presets/{pid}/';
